"use client";
import React, { useEffect, useState } from "react";
import Layout from "../../components/layout/Layout";
import "./customcss.css";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { TOKEN, config } from "../../config";
import Cookies from "universal-cookie";
import { getFormData } from "../../api/employeeDetails";
import { ChevronLeftIcon } from "@heroicons/react/solid";
import useDownloadGet from "../../hooks/useDownloadGet";
import toast from "react-hot-toast";

const getDateRangeString = (date) => {
  const tempDate = new Date(date);
  const startYear = tempDate.getFullYear();
  const endYear = startYear + 1;
  return `${startYear}-${endYear}`;
};

function Form16Input() {
  function formatDate(date) {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero based
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  const [searchParams] = useSearchParams();
  const location = useLocation();
  const { id, financial_year, prev_month_and_year, name } =
    location.state || {};
  const [formData, setFormData] = useState({
    department_name: "",
    form_id: "",
    user_id: "",
    form_date: "",
    assessment_year: "",
    period_from: "",
    period_to: "",
    gross_salary: "",
    gross_salary_total: "",
    balance: "",
    standard_deduction: "",
    entertainment_allowance: "",
    total_pt: "",
    contribution_pf_gross_amount: "",
    contribution_pf_deduction_amount: "",
    total_pf_gross_amount: "",
    total_pf_deduction_amount: "",
    deductible_amount_chapter_4: "",
    total_tax: "",
    education_cess: "",
    less_relief: "",
    section_80c_2_label: "",
    section_80c_3_label: "",
    section_80c_4_label: "",
    section_80c_5_label: "",
    section_80c_6_label: "",
    section_80c_7_label: "",
    section_80c_8_label: "",
    section_80c_2_gross_amount: "",
    section_80c_3_gross_amount: "",
    section_80c_4_gross_amount: "",
    section_80c_5_gross_amount: "",
    section_80c_6_gross_amount: "",
    section_80c_7_gross_amount: "",
    section_80c_8_gross_amount: "",
    section_80c_2_deduction_amount: "",
    section_80c_3_deduction_amount: "",
    section_80c_4_deduction_amount: "",
    section_80c_5_deduction_amount: "",
    section_80c_6_deduction_amount: "",
    section_80c_7_deduction_amount: "",
    section_80c_8_deduction_amount: "",
    other_section_1_label: "",
    other_section_2_label: "",
    other_section_3_label: "",
    other_section_4_label: "",
    other_section_5_label: "",
    other_section_1_gross_amount: "",
    other_section_2_gross_amount: "",
    other_section_3_gross_amount: "",
    other_section_4_gross_amount: "",
    other_section_5_gross_amount: "",
    other_section_1_qualify_amount: "",
    other_section_2_qualify_amount: "",
    other_section_3_qualify_amount: "",
    other_section_4_qualify_amount: "",
    other_section_5_qualify_amount: "",
    other_section_1_deduction_amount: "",
    other_section_2_deduction_amount: "",
    other_section_3_deduction_amount: "",
    other_section_4_deduction_amount: "",
    other_section_5_deduction_amount: "",
    other_section_gross_amount_total: "",
    other_section_qualify_amount_total: "",
    other_section_deduction_amount_total: "",
  }); // State to store form data
  const [token, setToken] = useState(null); // State to store access token
  const cookies = new Cookies();
  // Function to fetch form data (replace with actual logic if needed)
  const navigate = useNavigate();
  const fetchFormData = async () => {
    try {
      const token = cookies.get(TOKEN); // Retrieve token from cookies
      const data = {
        financial_year: getDateRangeString(searchParams.get("year")),
        user_id: searchParams.get("id"),
      };
      const response = await getFormData(data);
      console.log(response.data.data);
      setFormData(response.data.data);
      if (response.data.success) {
        // Assuming success, check for the presence of formData
        if (response.data.formData) {
        } else {
          console.warn("API response missing formData property");
        }
      } else {
        console.error("Error fetching data:", response.data.error); // Handle errors
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      // Handle errors appropriately
    }
  };

  // Function to retrieve token from cookies (replace with your specific logic)
  const getTokenFromCookies = () => {
    const retrievedToken = Cookies.get(TOKEN); // Replace with your cookie key
    setToken(retrievedToken);
  };

  useEffect(() => {
    // Fetch data only once on component mount
    fetchFormData();
  }, [id, financial_year]); // Empty dependency array ensures it runs only once

  // Optionally, fetch data again if token changes:
  useEffect(() => {
    if (token) {
      // Only fetch if token exists
      fetchFormData();
    }
  }, [token]); // Re-fetch data if token changes

  // Function to handle form submission (replace with actual logic)
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevData) => {
      const updatedData = {
        ...prevData,
        [name]: value,
      };

      // Update related fields when contribution_pf_gross_amount or gross_salary changes
      if (name === "contribution_pf_gross_amount") {
        updatedData.contribution_pf_deduction_amount = value;
        // updatedData.total_pf_deduction_amount = value;
        // updatedData.total_pf_gross_amount = value;
        // updatedData.deductible_amount_chapter_4 = value;
      }

      if (name === "gross_salary") {
        updatedData.gross_salary_total = value;
        updatedData.balance = value;
      }

      if (name === "section_80c_2_gross_amount") {
        updatedData.section_80c_2_deduction_amount = value;
        // Add other related fields if needed
      }
  
      // Update related fields for section_80c_3_gross_amount
      if (name === "section_80c_3_gross_amount") {
        updatedData.section_80c_3_deduction_amount = value;
        // Add other related fields if needed
      }
      if (name === "section_80c_4_gross_amount") {
        updatedData.section_80c_4_deduction_amount = value;
        // Add other related fields if needed
      }
      if (name === "section_80c_5_gross_amount") {
        updatedData.section_80c_5_deduction_amount = value;
        // Add other related fields if needed
      }
      if (name === "section_80c_6_gross_amount") {
        updatedData.section_80c_6_deduction_amount = value;
        // Add other related fields if needed
      }
      if (name === "section_80c_7_gross_amount") {
        updatedData.section_80c_7_deduction_amount = value;
        // Add other related fields if needed
      }
      if (name === "section_80c_8_gross_amount") {
        updatedData.section_80c_8_deduction_amount = value;
        // Add other related fields if needed
      }
      return updatedData;
    });
  };
  const calculateTotalPfGrossAmount = () => {
    const section80C1 = parseFloat(formData.contribution_pf_gross_amount) || 0;
    const section80C2 = parseFloat(formData.section_80c_2_gross_amount) || 0;
    const section80C3 = parseFloat(formData.section_80c_3_gross_amount) || 0;
    const section80C4 = parseFloat(formData.section_80c_4_gross_amount) || 0;
    const section80C5 = parseFloat(formData.section_80c_5_gross_amount) || 0;
    const section80C6 = parseFloat(formData.section_80c_6_gross_amount) || 0;
    const section80C7 = parseFloat(formData.section_80c_7_gross_amount) || 0;
    const section80C8 = parseFloat(formData.section_80c_8_gross_amount) || 0;
  
    const totalPfGrossAmount =
      section80C1 +
      section80C2 +
      section80C3 +
      section80C4 +
      section80C5 +
      section80C6 +
      section80C7 +
      section80C8;
  
    setFormData(prevData => ({
      ...prevData,
      total_pf_gross_amount: totalPfGrossAmount.toFixed(2), // Round to two decimal places if needed
    }));
  };
  
  useEffect(() => {
    calculateTotalPfGrossAmount();
  }, [
    formData.contribution_pf_gross_amount,
    formData.section_80c_2_gross_amount,
    formData.section_80c_3_gross_amount,
    formData.section_80c_4_gross_amount,
    formData.section_80c_5_gross_amount,
    formData.section_80c_6_gross_amount,
    formData.section_80c_7_gross_amount,
    formData.section_80c_8_gross_amount,
  ]);
  const calculateOtherSectionGrossAmountTotal = () => {
    const otherSection1 = parseFloat(formData.other_section_1_gross_amount) || 0;
    const otherSection2 = parseFloat(formData.other_section_2_gross_amount) || 0;
    const otherSection3 = parseFloat(formData.other_section_3_gross_amount) || 0;
    const otherSection4 = parseFloat(formData.other_section_4_gross_amount) || 0;
    const otherSection5 = parseFloat(formData.other_section_5_gross_amount) || 0;
  
    const otherSectionGrossAmountTotal =
      otherSection1 +
      otherSection2 +
      otherSection3 +
      otherSection4 +
      otherSection5;
  
    setFormData(prevData => ({
      ...prevData,
      other_section_gross_amount_total: otherSectionGrossAmountTotal.toFixed(2), // Round to two decimal places if needed
    }));
  };
  
  useEffect(() => {
    calculateOtherSectionGrossAmountTotal();
  }, [
    formData.other_section_1_gross_amount,
    formData.other_section_2_gross_amount,
    formData.other_section_3_gross_amount,
    formData.other_section_4_gross_amount,
    formData.other_section_5_gross_amount,
  ]);
  const calculateOtherSectionQualifyAmountTotal = () => {
    const otherSection1 = parseFloat(formData.other_section_1_qualify_amount) || 0;
    const otherSection2 = parseFloat(formData.other_section_2_qualify_amount) || 0;
    const otherSection3 = parseFloat(formData.other_section_3_qualify_amount) || 0;
    const otherSection4 = parseFloat(formData.other_section_4_qualify_amount) || 0;
    const otherSection5 = parseFloat(formData.other_section_5_qualify_amount) || 0;
  
    const otherSectionQualifyAmountTotal =
      otherSection1 +
      otherSection2 +
      otherSection3 +
      otherSection4 +
      otherSection5;
  
    setFormData(prevData => ({
      ...prevData,
      other_section_qualify_amount_total: otherSectionQualifyAmountTotal.toFixed(2), // Round to two decimal places if needed
    }));
  };
  
  useEffect(() => {
    calculateOtherSectionQualifyAmountTotal();
  }, [
    formData.other_section_1_qualify_amount,
    formData.other_section_2_qualify_amount,
    formData.other_section_3_qualify_amount,
    formData.other_section_4_qualify_amount,
    formData.other_section_5_qualify_amount,
  ]);
  const calculateOtherSectionDeductionAmountTotal = () => {
    const otherSection1 = parseFloat(formData.other_section_1_deduction_amount) || 0;
    const otherSection2 = parseFloat(formData.other_section_2_deduction_amount) || 0;
    const otherSection3 = parseFloat(formData.other_section_3_deduction_amount) || 0;
    const otherSection4 = parseFloat(formData.other_section_4_deduction_amount) || 0;
    const otherSection5 = parseFloat(formData.other_section_5_deduction_amount) || 0;
  
    const otherSectionDeductionAmountTotal =
      otherSection1 +
      otherSection2 +
      otherSection3 +
      otherSection4 +
      otherSection5;
  
    setFormData(prevData => ({
      ...prevData,
      other_section_deduction_amount_total: otherSectionDeductionAmountTotal.toFixed(2), // Round to two decimal places if needed
    }));
  };
  
  useEffect(() => {
    calculateOtherSectionDeductionAmountTotal();
  }, [
    formData.other_section_1_deduction_amount,
    formData.other_section_2_deduction_amount,
    formData.other_section_3_deduction_amount,
    formData.other_section_4_deduction_amount,
    formData.other_section_5_deduction_amount,
  ]);
  const calculateDeductibleAmountChapter4 = () => {
    const totalPfDeductionAmount = parseFloat(formData.total_pf_deduction_amount) || 0;
    const otherSectionDeductionAmountTotal = parseFloat(formData.other_section_deduction_amount_total) || 0;
  
    const deductibleAmountChapter4 = totalPfDeductionAmount + otherSectionDeductionAmountTotal;
  
    setFormData(prevData => ({
      ...prevData,
      deductible_amount_chapter_4: deductibleAmountChapter4.toFixed(2), // Round to two decimal places if needed
    }));
  };
  
  useEffect(() => {
    calculateDeductibleAmountChapter4();
  }, [
    formData.total_pf_deduction_amount,
    formData.other_section_deduction_amount_total,
  ]);
  
  const calculateTotalPfDeductionAmount = () => {
    const section80C1 = parseFloat(formData.contribution_pf_deduction_amount) || 0;
    const section80C2 = parseFloat(formData.section_80c_2_deduction_amount) || 0;
    const section80C3 = parseFloat(formData.section_80c_3_deduction_amount) || 0;
    const section80C4 = parseFloat(formData.section_80c_4_deduction_amount) || 0;
    const section80C5 = parseFloat(formData.section_80c_5_deduction_amount) || 0;
    const section80C6 = parseFloat(formData.section_80c_6_deduction_amount) || 0;
    const section80C7 = parseFloat(formData.section_80c_7_deduction_amount) || 0;
    const section80C8 = parseFloat(formData.section_80c_8_deduction_amount) || 0;
  
    let totalPfDeductionAmount =
      section80C1 +
      section80C2 +
      section80C3 +
      section80C4 +
      section80C5 +
      section80C6 +
      section80C7 +
      section80C8;
  
    // Apply the maximum limit of 150000
    if (totalPfDeductionAmount > 150000) {
      totalPfDeductionAmount = 150000;
    }
  
    setFormData(prevData => ({
      ...prevData,
      total_pf_deduction_amount: totalPfDeductionAmount.toFixed(2), // Round to two decimal places if needed
    }));
  };
  
  useEffect(() => {
    calculateTotalPfDeductionAmount();
  }, [
    formData.contribution_pf_deduction_amount,
    formData.section_80c_2_deduction_amount,
    formData.section_80c_3_deduction_amount,
    formData.section_80c_4_deduction_amount,
    formData.section_80c_5_deduction_amount,
    formData.section_80c_6_deduction_amount,
    formData.section_80c_7_deduction_amount,
    formData.section_80c_8_deduction_amount,
  ]);
  
  useEffect(() => {
    if (
      formData.standard_deduction !== undefined &&
      formData.total_pt !== undefined
    ) {
      calculateTotalDeduction(); // Calculate total deduction when necessary data is ready
    }
  }, [formData.standard_deduction, formData.total_pt]);
  const calculateTaxPayable = () => {
    const totalTax = parseFloat(formData.total_tax) || 0;
    const educationCess = parseFloat(formData.education_cess) || 0;
    const taxPayable = totalTax + educationCess;

    setFormData((prevData) => ({
      ...prevData,
      tax_payable: taxPayable.toFixed(2), // Round to two decimal places if needed
    }));
  };
  useEffect(() => {
    calculateTaxPayable();
  }, [formData.total_tax, formData.education_cess]);
  const calculateTotalTaxPayable = () => {
    const taxPayable = parseFloat(formData.tax_payable) || 0;
    const lessRelief = parseFloat(formData.less_relief) || 0;
    const totalTaxPayable = taxPayable - lessRelief;
    setFormData((prevData) => ({
      ...prevData,
      total_tax_payable: totalTaxPayable.toFixed(2),
    }));
  };
  useEffect(() => {
    calculateTotalTaxPayable();
  }, [formData.tax_payable, formData.less_relief]);
  const calculateTotalDeduction = () => {
    const standardDeduction = parseFloat(formData.standard_deduction) || 0;
    const totalPT = parseFloat(formData.total_pt) || 0;
    const entertainmentAllowance =
      parseFloat(formData.entertainment_allowance) || 0;
    const totalDeduction = standardDeduction + totalPT + entertainmentAllowance;
    setFormData((prevData) => ({
      ...prevData,
      total_deduction: totalDeduction.toFixed(2),
    }));
  };
  useEffect(() => {
    calculateFinalIncome();
  }, [formData.gross_total_income, formData.deductible_amount_chapter_4]);
  // Function to calculate final income based on gross_total_income and deductible_amount_chapter_4
  const calculateFinalIncome = () => {
    const grossTotalIncome = parseFloat(formData.gross_total_income) || 0;
    const deductibleAmountChapter4 =
      parseFloat(formData.deductible_amount_chapter_4) || 0;
    const finalIncome = grossTotalIncome - deductibleAmountChapter4;
    setFormData((prevData) => ({
      ...prevData,
      final_income: finalIncome.toFixed(2),
    }));
  };

  const calculateChargeableIncome = () => {
    const balance = parseFloat(formData.balance) || 0;
    const totalDeduction = parseFloat(formData.total_deduction) || 0;
    const chargeableIncome = balance - totalDeduction;
    setFormData((prevData) => ({
      ...prevData,
      chargebale_income: chargeableIncome.toFixed(2),
      gross_total_income: chargeableIncome.toFixed(2), // Set gross_total_income same as chargeable_income
    }));
  };
  useEffect(() => {
    calculateChargeableIncome();
  }, [formData.total_deduction, formData.balance]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Create a new instance of FormData
    const formDataToSend = new FormData();

    // Append each field from your state formData to formDataToSend
    Object.keys(formData).forEach((key) => {
      formDataToSend.append(key, formData[key]);
    });

    let token = cookies.get(TOKEN);
    try {
      const response = await fetch(
        "https://api-hr.payalsinghal.net/create_and_update_form16",
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            // No Content-Type header needed for FormData
          },
          body: formDataToSend, // Use formDataToSend here
        }
      );

      if (!response.ok) {
        throw new Error("Failed to submit form data");
      }

      const data = await response.json();
      console.log("Form submitted successfully:", data);
      alert("Form submitted successfully");
      // Optionally reset form fields or show success message
    } catch (error) {
      console.error("Error submitting form:", error.message);
      // Handle error scenarios (e.g., show error message)
    }
  };

  // const handleDownloadClick = () => {
  //   const form_id = {form_id}; // Replace with dynamic form_id if needed
  //   downloadForm(form_id);
  // };

  // const handleDownloadClick = () => {
  //   const form_id = formData.form_id; 
  //   downloadFile(form_id);
  // };
  // const downloadFile = (form_id) => {
  //   const apiUrl = `https://sapi-hr.payalsinghal.net/print_form_16?form_id=${form_id}`; // Include form_id in the URL
  //   let token = cookies.get(TOKEN);

  //   fetch(apiUrl, {
  //     method: "GET",
  //     headers: {
  //       // "Content-Type": "application/pdf",
  //       Authorization: `Bearer ${token}`,
  //     },
  //      responseType: 'blob'
  //   })
  //     .then((response) => {
  //       if (!response.ok) {
  //         throw new Error("Network response was not ok");
  //       }
  //       return response.blob(); // Convert response to a blob
  //     })
  //     .then((blob) => {
  //       const url = window.URL.createObjectURL(blob);
  //       const a = document.createElement("a");
  //       a.href = url;
  //       a.download = `DownloadedFile_${form_id}.pdf`; // Dynamic name for the downloaded file
  //       document.body.appendChild(a);
  //       a.click();
  //       a.remove();
  //       window.URL.revokeObjectURL(url); // Clean up the URL object
  //     })
  //     .catch((error) => {
  //       console.error("There was a problem with the fetch operation:", error);
  //     });
  // };
  const { reportDownload } = useDownloadGet({
    url: `print_form_16?form_id=${formData.form_id}`, // Adjust the URL as needed
    filename: `DownloadedFile_${formData.form_id}.pdf`, // Dynamic filename
    onError: () => {
        toast.error('There was an error while downloading the file');
    }
});
const handleTotalPfDeductionChange = (event) => {
  let value = parseFloat(event.target.value);
  
  if (value > 150000) {
    value = 150000; // Limit to 150000 if exceeded
  }

  // Update the formData or state variable with the validated value
  setFormData(prevData => ({
    ...prevData,
    total_pf_deduction_amount: value,
  }));
};

const handleDownloadClick = (e) => {
    e.preventDefault();
    reportDownload.mutate(); // Start the download process
};
  return (
    <Layout>
      <div className="mx-6 my-4 flex justify-between items-center">
        <button
          onClick={() => navigate(-1, { replace: true })}
          className="flex items-center hover:underline"
        >
          <ChevronLeftIcon className="w-6 h-6" />
          <span className="font-semibold">Back</span>
        </button>
        <a
          download
          // href={`https://sapi-hr.payalsinghal.net/print_form_16?form_id=${formData.form_id}`}
          href='#'
          onClick={handleDownloadClick}
          className=" text-blue-500 font-semibold hover:underline"
        >
          Download Form 16
        </a>
      </div>
      <form onSubmit={handleSubmit}>
        <div>
          <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
          <title>Form 16 Format.xls</title>
          <meta name="author" content="Khantil Vira" />
          <style
            type="text/css"
            dangerouslySetInnerHTML={{
              __html:
                '\n      * {\n        margin: 0;\n         padding: 10;\n        text-indent: 0;\n       ;\n      }\n\n      .s1 {\n        color: black;\n        font-family: "Book Antiqua", serif;\n        font-style: normal;\n        font-weight: bold;\n        text-decoration: none;\n        font-size: 8.5pt;\n      }\n\n      .s2 {\n        color: black;\n        font-family: "Book Antiqua", serif;\n        font-style: normal;\n        font-weight: normal;\n        text-decoration: none;\n        font-size: 8.5pt;\n      }\n\n      .s3 {\n        color: black;\n        font-family: "Book Antiqua", serif;\n        font-style: normal;\n        font-weight: normal;\n        text-decoration: none;\n        font-size: 7.5pt;\n      }\n\n      p {\n        color: black;\n        font-family: "Book Antiqua", serif;\n        font-style: normal;\n        font-weight: normal;\n        text-decoration: none;\n        font-size: 8.5pt;\n        margin: 0pt;\n      }\n\n      .s4 {\n        color: black;\n   margin: 3pt;\n    height: 10pt;\n    font-family: "Book Antiqua", serif;\n        font-style: normal;\n        font-weight: normal;\n        text-decoration: none;\n        font-size: 8pt;\n      }\n\n      .s5 {\n        color: black;\n        font-family: "Book Antiqua", serif;\n        font-style: normal;\n        font-weight: normal;\n        text-decoration: none;\n        font-size: 7pt;\n      }\n\n      li {\n        display: block;\n      }\n\n      #l1 {\n        padding-left: 0pt;\n        counter-reset: c1 1;\n      }\n\n      #l1>li>*:first-child:before {\n        counter-increment: c1;\n        content: counter(c1, decimal)". ";\n        color: black;\n        font-family: "Book Antiqua", serif;\n        font-style: normal;\n        font-weight: normal;\n        text-decoration: none;\n        font-size: 8.5pt;\n      }\n\n      #l1>li:first-child>*:first-child:before {\n        counter-increment: c1 0;\n      }\n\n      #l2 {\n        padding-left: 0pt;\n        counter-reset: c2 1;\n      }\n\n      #l2>li>*:first-child:before {\n        counter-increment: c2;\n        content: "("counter(c2, lower-latin)") ";\n        color: black;\n        font-family: "Book Antiqua", serif;\n        font-style: normal;\n        font-weight: normal;\n        text-decoration: none;\n        font-size: 7.5pt;\n      }\n\n      #l2>li:first-child>*:first-child:before {\n        counter-increment: c2 0;\n      }\n\n      li {\n        display: block;\n      }\n\n      #l3 {\n        padding-left: 0pt;\n        counter-reset: d1 3;\n      }\n\n      #l3>li>*:first-child:before {\n        counter-increment: d1;\n        content: counter(d1, decimal)". ";\n        color: black;\n        font-family: "Book Antiqua", serif;\n        font-style: normal;\n        font-weight: normal;\n        text-decoration: none;\n        font-size: 8.5pt;\n      }\n\n      #l3>li:first-child>*:first-child:before {\n        counter-increment: d1 0;\n      }\n\n      #l4 {\n        padding-left: 0pt;\n        counter-reset: d2 1;\n      }\n\n      #l4>li>*:first-child:before {\n        counter-increment: d2;\n        content: "("counter(d2, lower-latin)") ";\n        color: black;\n        font-family: "Book Antiqua", serif;\n        font-style: normal;\n        font-weight: normal;\n        text-decoration: none;\n        font-size: 8.5pt;\n      }\n\n      #l4>li:first-child>*:first-child:before {\n        counter-increment: d2 0;\n      }\n\n      li {\n        display: block;\n      }\n\n      #l5 {\n        padding-left: 0pt;\n        counter-reset: e1 9;\n      }\n\n      #l5>li>*:first-child:before {\n        counter-increment: e1;\n        content: counter(e1, decimal)". ";\n        color: black;\n        font-family: "Book Antiqua", serif;\n        font-style: normal;\n        font-weight: normal;\n        text-decoration: none;\n        font-size: 8.5pt;\n      }\n\n      #l5>li:first-child>*:first-child:before {\n        counter-increment: e1 0;\n      }\n\n      #l6 {\n        padding-left: 0pt;\n        counter-reset: e2 1;\n      }\n\n      #l6>li>*:first-child:before {\n        counter-increment: e2;\n        content: "("counter(e2, upper-latin)") ";\n        color: black;\n        font-family: "Book Antiqua", serif;\n        font-style: normal;\n        font-weight: normal;\n        text-decoration: none;\n        font-size: 8.5pt;\n      }\n\n      #l6>li:first-child>*:first-child:before {\n        counter-increment: e2 0;\n      }\n\n      #l7 {\n        padding-left: 0pt;\n        counter-reset: e3 1;\n      }\n\n      #l7>li>*:first-child:before {\n        counter-increment: e3;\n        content: "("counter(e3, lower-latin)") ";\n        color: black;\n        font-family: "Book Antiqua", serif;\n        font-style: normal;\n        font-weight: normal;\n        text-decoration: none;\n        font-size: 8.5pt;\n      }\n\n      #l7>li:first-child>*:first-child:before {\n        counter-increment: e3 0;\n      }\n\n      #l8 {\n        padding-left: 0pt;\n        counter-reset: e4 1;\n      }\n\n      #l8>li>*:first-child:before {\n        counter-increment: e4;\n        content: "("counter(e4, lower-roman)") ";\n        color: black;\n        font-family: "Book Antiqua", serif;\n        font-style: normal;\n        font-weight: normal;\n        text-decoration: none;\n        font-size: 8.5pt;\n      }\n\n      #l8>li:first-child>*:first-child:before {\n        counter-increment: e4 0;\n      }\n\n      li {\n        display: block;\n      }\n\n      #l9 {\n        padding-left: 0pt;\n        counter-reset: f1 2;\n      }\n\n      #l9>li>*:first-child:before {\n        counter-increment: f1;\n        content: "("counter(f1, upper-latin)") ";\n        color: black;\n        font-family: "Book Antiqua", serif;\n        font-style: normal;\n        font-weight: normal;\n        text-decoration: none;\n        font-size: 7.5pt;\n      }\n\n      #l9>li:first-child>*:first-child:before {\n        counter-increment: f1 0;\n      }\n\n      #l10 {\n        padding-left: 0pt;\n        counter-reset: f2 1;\n      }\n\n      #l10>li>*:first-child:before {\n        counter-increment: f2;\n        content: "("counter(f2, lower-roman)") ";\n        color: black;\n        font-family: "Book Antiqua", serif;\n        font-style: normal;\n        font-weight: normal;\n        text-decoration: none;\n        font-size: 8.5pt;\n      }\n\n      #l10>li:first-child>*:first-child:before {\n        counter-increment: f2 0;\n      }\n\n      li {\n        display: block;\n      }\n\n      #l11 {\n        padding-left: 0pt;\n        counter-reset: g1 10;\n      }\n\n      #l11>li>*:first-child:before {\n        counter-increment: g1;\n        content: counter(g1, decimal)". ";\n        color: black;\n        font-style: normal;\n        font-weight: normal;\n        text-decoration: none;\n      }\n\n      #l11>li:first-child>*:first-child:before {\n        counter-increment: g1 0;\n      }\n\n      table,\n      tbody {\n        vertical-align: top;\n        overflow: visible;\n      }\n    ',
            }}
          />
          <table
            style={{
              borderCollapse: "collapse",
              width: "90%",
              marginLeft: "27.895pt",
            }}
            cellSpacing={0}
          >
            <tbody>
              <tr style={{ height: "11pt" }}>
                <td
                  style={{
                    width: "426pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  colSpan={5}
                >
                  <p
                    className="s1"
                    style={{
                      paddingLeft: "1pt",
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "center",
                    }}
                  >
                    FORM 16
                  </p>
                </td>
              </tr>
              <tr style={{ height: "11pt" }}>
                <td
                  style={{
                    width: "426pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  colSpan={5}
                >
                  <p
                    className="s2"
                    style={{
                      paddingLeft: "1pt",
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "center",
                    }}
                  >
                    [See rule 31(1)(a)]
                  </p>
                </td>
              </tr>
              <tr style={{ height: "11pt" }}>
                <td
                  style={{
                    width: "426pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  colSpan={5}
                >
                  <p
                    className="s1"
                    style={{
                      paddingLeft: "1pt",
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "center",
                    }}
                  >
                    PART A
                  </p>
                </td>
              </tr>
              <tr style={{ height: "13pt" }}>
                <td
                  style={{
                    width: "426pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  colSpan={5}
                >
                  <p
                    className="s2"
                    style={{
                      paddingLeft: "35pt",
                      textIndent: "0pt",
                      textAlign: "left",
                    }}
                  >
                    Certificate under section 203 of the Income-tax Act, 1961
                    for Tax deducted at source on Salary
                  </p>
                </td>
              </tr>
              <tr style={{ height: "11pt" }}>
                <td
                  style={{
                    width: "197pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  colSpan={2}
                >
                  <p
                    className="s2"
                    style={{
                      paddingLeft: "30pt",
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "left",
                    }}
                  >
                    Name and address of the Employer
                  </p>
                </td>
                <td
                  style={{
                    width: "229pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  colSpan={3}
                >
                  <p
                    className="s2"
                    style={{
                      paddingLeft: "39pt",
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "left",
                    }}
                  >
                    Name and designation of the Employee
                  </p>
                </td>
              </tr>
              <tr style={{ height: "45pt" }}>
                <td
                  style={{
                    width: "197pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  colSpan={2}
                >
                  <p
                    className="s2"
                    style={{
                      paddingLeft: "1pt",
                      paddingRight: "24pt",
                      textIndent: "0pt",
                      lineHeight: "107%",
                      textAlign: "left",
                    }}
                  >
                    PAYAL SINGHAL DESIGN HOUSE LLP 1ST FLOOR, NARAYAN PLAZA,
                    135, RAM MANDIR ROAD, OFF SV ROAD, BEHIND
                  </p>
                  <p
                    className="s2"
                    style={{
                      paddingLeft: "1pt",
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "left",
                    }}
                  >
                    SINGH IND ESTATE, GOREGAON (W)-400104
                  </p>
                </td>
                <td
                  style={{
                    width: "229pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  colSpan={3}
                >
                  <p
                    className="s2"
                    style={{
                      paddingLeft: "98pt",
                      paddingRight: "15pt",
                      textIndent: "-53pt",
                      lineHeight: "107%",
                      textAlign: "left",
                    }}
                  >
                    {formData.name}
                  </p>
                  <p
                    className="s2"
                    style={{
                      paddingLeft: "98pt",
                      paddingRight: "15pt",
                      textIndent: "-53pt",
                      lineHeight: "107%",
                      textAlign: "left",
                    }}
                  >
                    {formData.department_name}
                  </p>
                </td>
              </tr>
              <tr style={{ height: "11pt" }}>
                <td
                  style={{
                    width: "197pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  colSpan={2}
                >
                  <p
                    className="s2"
                    style={{
                      paddingLeft: "58pt",
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "left",
                    }}
                  >
                    PAN of the Deductor
                  </p>
                </td>
                <td
                  style={{
                    width: "79pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p
                    className="s2"
                    style={{
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "left",
                    }}
                  >
                    TAN of the Deducto
                  </p>
                </td>
                <td
                  style={{
                    width: "150pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  colSpan={2}
                >
                  <p
                    className="s2"
                    style={{
                      paddingLeft: "33pt",
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "left",
                    }}
                  >
                    PAN of the Employee
                  </p>
                </td>
              </tr>
              <tr style={{ height: "11pt" }}>
                <td
                  style={{
                    width: "197pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  colSpan={2}
                >
                  <p
                    className="s2"
                    style={{
                      paddingLeft: "1pt",
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "center",
                    }}
                  >
                    AAQFP6012R
                  </p>
                </td>
                <td
                  style={{
                    width: "79pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p
                    className="s2"
                    style={{
                      paddingLeft: "1pt",
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "left",
                    }}
                  >
                    MUMP34062A
                  </p>
                </td>
                <td
                  style={{
                    width: "150pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  colSpan={2}
                >
                  <p
                    className="s2"
                    style={{
                      paddingLeft: "49pt",
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "left",
                    }}
                  >
                    {formData.pan}
                  </p>
                </td>
              </tr>
              <tr style={{ height: "11pt" }}>
                <td
                  style={{
                    width: "197pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  colSpan={2}
                  rowSpan={3}
                >
                  <p
                    className="s2"
                    style={{
                      paddingLeft: "1pt",
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "center",
                    }}
                  >
                    CIT (TDS)
                  </p>
                </td>
                <td
                  style={{
                    width: "79pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p
                    className="s2"
                    style={{
                      paddingLeft: "7pt",
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "left",
                    }}
                  >
                    Assessment Year
                  </p>
                </td>
                <td
                  style={{
                    width: "150pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  colSpan={2}
                >
                  <p
                    className="s2"
                    style={{
                      paddingLeft: "1pt",
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "center",
                    }}
                  >
                    Period
                  </p>
                </td>
              </tr>
              <tr style={{ height: "11pt" }}>
                <td
                  style={{
                    width: "79pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  rowSpan={2}
                >
                  <p
                    style={{
                      paddingTop: "1pt",
                      textIndent: "0pt",
                      textAlign: "left",
                    }}
                  >
                    <br />
                  </p>
                  <p
                    className="s2"
                    style={{
                      paddingLeft: "25pt",
                      textIndent: "0pt",
                      textAlign: "left",
                    }}
                  >
                    {formData.assessment_year}
                  </p>
                </td>
                <td
                  style={{
                    width: "78pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p
                    className="s2"
                    style={{
                      paddingLeft: "1pt",
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "center",
                    }}
                  >
                    From
                  </p>
                </td>
                <td
                  style={{
                    width: "72pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p
                    className="s2"
                    style={{
                      paddingLeft: "1pt",
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "center",
                    }}
                  >
                    To
                  </p>
                </td>
              </tr>
              <tr style={{ height: "22pt" }}>
                <td
                  style={{
                    width: "78pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p
                    className="s2"
                    style={{
                      paddingTop: "5pt",
                      paddingLeft: "20pt",
                      textIndent: "0pt",
                      textAlign: "left",
                    }}
                  >
                    {formData.period_from}
                  </p>
                </td>
                <td
                  style={{
                    width: "72pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p
                    className="s2"
                    style={{
                      paddingTop: "5pt",
                      paddingLeft: "16pt",
                      textIndent: "0pt",
                      textAlign: "left",
                    }}
                  >
                    {formData.period_to}
                  </p>
                </td>
              </tr>
              <tr style={{ height: "11pt" }}>
                <td
                  style={{
                    width: "426pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  colSpan={5}
                >
                  <p
                    className="s2"
                    style={{
                      paddingLeft: "1pt",
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "center",
                    }}
                  >
                    Summary of tax deducted at source
                  </p>
                </td>
              </tr>
              <tr style={{ height: "48pt" }}>
                <td
                  style={{
                    width: "88pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p
                    style={{
                      paddingTop: "8pt",
                      textIndent: "0pt",
                      textAlign: "left",
                    }}
                  >
                    <br />
                  </p>
                  <p
                    className="s2"
                    style={{
                      paddingLeft: "1pt",
                      textIndent: "0pt",
                      textAlign: "center",
                    }}
                  >
                    Quarter
                  </p>
                </td>
                <td
                  style={{
                    width: "188pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  colSpan={2}
                >
                  <p
                    style={{
                      paddingTop: "2pt",
                      textIndent: "0pt",
                      textAlign: "left",
                    }}
                  >
                    <br />
                  </p>
                  <p
                    className="s2"
                    style={{
                      paddingLeft: "26pt",
                      paddingRight: "3pt",
                      lineHeight: "107%",
                      textAlign: "left",
                    }}
                  >
                    Receipt Numbers of original statements of TDS under
                    sub-section (3) of section 200
                  </p>
                </td>
                <td
                  style={{
                    width: "78pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p
                    className="s2"
                    style={{
                      paddingTop: "6pt",
                      paddingLeft: "2pt",
                      textIndent: "0pt",
                      lineHeight: "107%",
                      textAlign: "center",
                    }}
                  >
                    Amount of tax deducted in respect of the employee
                  </p>
                </td>
                <td
                  style={{
                    width: "72pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p
                    className="s2"
                    style={{
                      paddingTop: "1pt",
                      paddingLeft: "3pt",
                      paddingRight: "1pt",
                      textIndent: "0pt",
                      lineHeight: "107%",
                      textAlign: "center",
                    }}
                  >
                    Amount of tax deposited/remitt ed in respect of the employee
                  </p>
                </td>
              </tr>
              <tr style={{ height: "11pt" }}>
                <td
                  style={{
                    width: "88pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p
                    className="s2"
                    style={{
                      paddingLeft: "1pt",
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "center",
                    }}
                  >
                    Quarter 1
                  </p>
                </td>
                <td
                  style={{
                    width: "188pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  colSpan={2}
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "78pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "72pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
              </tr>
              <tr style={{ height: "11pt" }}>
                <td
                  style={{
                    width: "88pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p
                    className="s2"
                    style={{
                      paddingLeft: "1pt",
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "center",
                    }}
                  >
                    Quarter 2
                  </p>
                </td>
                <td
                  style={{
                    width: "188pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  colSpan={2}
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "78pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "72pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
              </tr>
              <tr style={{ height: "11pt" }}>
                <td
                  style={{
                    width: "88pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p
                    className="s2"
                    style={{
                      paddingLeft: "1pt",
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "center",
                    }}
                  >
                    Quarter 3
                  </p>
                </td>
                <td
                  style={{
                    width: "188pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  colSpan={2}
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "78pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "72pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
              </tr>
              <tr style={{ height: "11pt" }}>
                <td
                  style={{
                    width: "88pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p
                    className="s2"
                    style={{
                      paddingLeft: "1pt",
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "center",
                    }}
                  >
                    Quarter 4
                  </p>
                </td>
                <td
                  style={{
                    width: "188pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  colSpan={2}
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "78pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "72pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
              </tr>
              <tr style={{ height: "11pt" }}>
                <td
                  style={{
                    width: "88pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p
                    className="s1"
                    style={{
                      paddingLeft: "1pt",
                      textIndent: "0pt",
                      lineHeight: "9pt",
                      textAlign: "center",
                    }}
                  >
                    Total
                  </p>
                </td>
                <td
                  style={{
                    width: "188pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  colSpan={2}
                  bgcolor="#959595"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "78pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p
                    className="s2"
                    style={{
                      paddingRight: "12pt",
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "center",
                    }}
                  >
                    -
                  </p>
                </td>
                <td
                  style={{
                    width: "72pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p
                    className="s2"
                    style={{
                      paddingRight: "12pt",
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "center",
                    }}
                  >
                    -
                  </p>
                </td>
              </tr>
              <tr style={{ height: "11pt" }}>
                <td
                  style={{
                    width: "426pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  colSpan={5}
                >
                  <p
                    className="s1"
                    style={{
                      paddingLeft: "1pt",
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "center",
                    }}
                  >
                    PART B (Refer Note 1)
                  </p>
                </td>
              </tr>
              <tr style={{ height: "11pt" }}>
                <td
                  style={{
                    width: "426pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  colSpan={5}
                >
                  <p
                    className="s1"
                    style={{
                      paddingLeft: "1pt",
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "left",
                    }}
                  >
                    Details of Salary Paid and any other income and tax deducted
                  </p>
                </td>
              </tr>
              <tr style={{ height: "11pt" }}>
                <td
                  style={{
                    width: "88pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "109pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "79pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p
                    className="s2"
                    style={{
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "center",
                    }}
                  >
                    Rs.
                  </p>
                </td>
                <td
                  style={{
                    width: "78pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p
                    className="s2"
                    style={{
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "center",
                    }}
                  >
                    Rs.
                  </p>
                </td>
                <td
                  style={{
                    width: "72pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p
                    className="s2"
                    style={{
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "center",
                    }}
                  >
                    Rs.
                  </p>
                </td>
              </tr>
              <tr style={{ height: "11pt" }}>
                <td
                  style={{
                    width: "197pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  colSpan={2}
                  rowSpan={7}
                >
                  <ol id="l1">
                    <li data-list-text={1}>
                      <p
                        className="s2"
                        style={{
                          paddingLeft: "12pt",
                          textIndent: "-10pt",
                          lineHeight: "10pt",
                          textAlign: "left",
                        }}
                      >
                        Gross Salary
                      </p>
                      <ol id="l2">
                        <li data-list-text="(a)">
                          <p
                            className="s3"
                            style={{
                              paddingTop: "5pt",
                              paddingLeft: "29pt",
                              textIndent: "-11pt",
                              textAlign: "left",
                            }}
                          >
                            Salary as per provisions contained in sec. 17(1)
                          </p>
                        </li>
                        <li data-list-text="(b)">
                          <p
                            className="s3"
                            style={{
                              paddingTop: "12pt",
                              paddingLeft: "51pt",
                              paddingRight: "6pt",
                              textIndent: "-36pt",
                              lineHeight: "111%",
                              textAlign: "left",
                            }}
                          >
                            Value of perquisites u/s 17(2) (as per Form No.
                            12BB, wherever applicable)
                          </p>
                        </li>
                        <li data-list-text="(c)">
                          <p
                            className="s3"
                            style={{
                              paddingTop: "15pt",
                              paddingLeft: "17pt",
                              paddingRight: "5pt",
                              textIndent: "0pt",
                              lineHeight: "111%",
                              textAlign: "left",
                            }}
                          >
                            Profits in lieu of salary under section 17(3)(as per
                            Form No. 12BB, wherever applicable
                          </p>
                        </li>
                        <li data-list-text="(d)">
                          <p
                            className="s3"
                            style={{
                              paddingTop: "11pt",
                              paddingLeft: "30pt",
                              textIndent: "-11pt",
                              textAlign: "left",
                            }}
                          >
                            Total
                          </p>
                          <p
                            style={{
                              paddingTop: "4pt",
                              textIndent: "0pt",
                              textAlign: "left",
                            }}
                          >
                            <br />
                          </p>
                        </li>
                      </ol>
                    </li>
                    <li data-list-text={2}>
                      <p
                        className="s2"
                        style={{
                          paddingLeft: "10pt",
                          textIndent: "-8pt",
                          lineHeight: "10pt",
                          textAlign: "left",
                        }}
                      >
                        Less: Allowance to the extent exempt U/s 10
                      </p>
                    </li>
                  </ol>
                </td>
                <td
                  style={{
                    width: "79pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "78pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "72pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
              </tr>
              <tr style={{ height: "11pt" }}>
                <td
                  style={{
                    borderColor: "blue",
                    textAlign: "center",
                    width: "79pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "2pt",
                    // borderRightStyle: "solid",
                    // borderRightWidth: "1pt",

                    backgroundColor: "lightblue",
                  }}
                >
                  <input
                    name="gross_salary"
                    type="number"
                    className="s2"
                    style={{
                      paddingRight: "3pt",
                      textIndent: "0pt",
                      outline: "none",
                      textAlign: "center",
                      backgroundColor: "lightblue",
                    }}
                    value={formData.gross_salary}
                    onChange={handleInputChange}
                  />
                </td>
                <td
                  style={{
                    width: "78pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "72pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
              </tr>
              <tr style={{ height: "21pt" }}>
                <td
                  style={{
                    width: "79pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p
                    className="s2"
                    style={{
                      paddingTop: "9pt",
                      paddingRight: "12pt",
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "center",
                    }}
                  >
                    -
                  </p>
                </td>
                <td
                  style={{
                    width: "78pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "72pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
              </tr>
              <tr style={{ height: "24pt" }}>
                <td
                  style={{
                    width: "79pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p
                    style={{
                      paddingTop: "2pt",
                      textIndent: "0pt",
                      textAlign: "left",
                    }}
                  >
                    <br />
                  </p>
                  <p
                    className="s2"
                    style={{
                      paddingRight: "12pt",
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "center",
                    }}
                  >
                    -
                  </p>
                </td>
                <td
                  style={{
                    width: "78pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "72pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
              </tr>
              <tr style={{ height: "11pt" }}>
                <td
                  style={{
                    width: "79pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "78pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p
                    className="s2"
                    style={{
                      paddingRight: "3pt",
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "center",
                    }}
                  >
                    {formData.gross_salary_total}
                  </p>
                </td>
                <td
                  style={{
                    width: "72pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
              </tr>
              <tr style={{ height: "11pt" }}>
                <td
                  style={{
                    width: "79pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "78pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "72pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
              </tr>
              <tr style={{ height: "11pt" }}>
                <td
                  style={{
                    width: "79pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "78pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "72pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
              </tr>
              <tr style={{ height: "11pt" }}>
                <td
                  style={{
                    width: "88pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p
                    className="s2"
                    style={{
                      paddingLeft: "1pt",
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "center",
                    }}
                  >
                    Allowance
                  </p>
                </td>
                <td
                  style={{
                    width: "109pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p
                    className="s2"
                    style={{
                      paddingLeft: "1pt",
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "center",
                    }}
                  >
                    Rs.
                  </p>
                </td>
                <td
                  style={{
                    width: "79pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "78pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "72pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
              </tr>
              <tr style={{ height: "11pt" }}>
                <td
                  style={{
                    width: "88pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "109pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "79pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "78pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "72pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
              </tr>
              <tr style={{ height: "11pt" }}>
                <td
                  style={{
                    width: "88pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "109pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "79pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "78pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "72pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
              </tr>
              <tr style={{ height: "11pt" }}>
                <td
                  style={{
                    width: "88pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "109pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "79pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "78pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "72pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
              </tr>
              <tr style={{ height: "11pt" }}>
                <td
                  style={{
                    width: "88pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "109pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "79pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "78pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p
                    className="s2"
                    style={{
                      paddingRight: "12pt",
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "center",
                    }}
                  >
                    -
                  </p>
                </td>
                <td
                  style={{
                    width: "72pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
              </tr>
              <tr style={{ height: "11pt" }}>
                <td
                  style={{
                    width: "197pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                  }}
                  colSpan={2}
                  rowSpan={10}
                >
                  <p
                    style={{
                      paddingTop: "1pt",
                      textIndent: "0pt",
                      textAlign: "left",
                    }}
                  >
                    <br />
                  </p>
                  <ol id="l3">
                    <li data-list-text={3}>
                      <p
                        className="s2"
                        style={{
                          paddingLeft: "10pt",
                          textIndent: "-8pt",
                          textAlign: "left",
                        }}
                      >
                        Balance (1-2)
                      </p>
                    </li>
                    <li data-list-text={4}>
                      <p
                        className="s2"
                        style={{
                          paddingLeft: "10pt",
                          textIndent: "-8pt",
                          textAlign: "left",
                        }}
                      >
                        Deductions :
                      </p>
                      <ol id="l4">
                        <li data-list-text="(a)">
                          <p
                            className="s2"
                            style={{
                              paddingTop: "8pt",
                              paddingLeft: "24pt",
                              textIndent: "-12pt",
                              textAlign: "left",
                            }}
                          >
                            Standard deduction
                          </p>
                        </li>
                        <li data-list-text="(b)">
                          <p
                            className="s2"
                            style={{
                              paddingTop: "5pt",
                              paddingLeft: "24pt",
                              textIndent: "-12pt",
                              textAlign: "left",
                            }}
                          >
                            Entertainment allowance
                          </p>
                        </li>
                        <li data-list-text="(c)">
                          <p
                            className="s2"
                            style={{
                              paddingTop: "5pt",
                              paddingLeft: "24pt",
                              textIndent: "-11pt",
                              textAlign: "left",
                            }}
                          >
                            Tax on employment
                          </p>
                        </li>
                      </ol>
                    </li>
                    <li data-list-text={5}>
                      <p
                        className="s2"
                        style={{
                          marginTop: "7pt",
                          paddingLeft: "10pt",
                          textIndent: "-8pt",
                          textAlign: "left",
                        }}
                      >
                        Aggregate of 4(a) and (b)
                      </p>
                    </li>
                    <li data-list-text={6}>
                      <p
                        className="s2"
                        style={{
                          paddingTop: "5pt",
                          paddingLeft: "10pt",
                          textIndent: "-8pt",
                          textAlign: "left",
                        }}
                      >
                        Income chargebale under the head 'Salaries' (3-5)
                      </p>
                    </li>
                    <li data-list-text={7}>
                      <p
                        className="s2"
                        style={{
                          paddingTop: "3pt",
                          paddingLeft: "10pt",
                          textIndent: "-8pt",
                          lineHeight: "10pt",
                          textAlign: "left",
                        }}
                      >
                        Add: Any other income reported by the employee
                      </p>
                    </li>
                  </ol>
                </td>
                <td
                  style={{
                    width: "79pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "78pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "72pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
              </tr>
              <tr style={{ height: "11pt" }}>
                <td
                  style={{
                    width: "79pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "78pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p
                    className="s2"
                    style={{
                      paddingRight: "3pt",
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "center",
                    }}
                  >
                    {formData.balance}
                  </p>
                </td>
                <td
                  style={{
                    width: "72pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
              </tr>
              <tr style={{ height: "11pt" }}>
                <td
                  style={{
                    width: "79pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "78pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "72pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
              </tr>
              <tr style={{ height: "11pt" }}>
                <td
                  style={{
                    borderColor: "blue",
                    textAlign: "center",
                    width: "79pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",

                    borderBottomStyle: "solid",
                    borderBottomWidth: "2pt",
                    backgroundColor: "lightblue",
                  }}
                >
                  <input
                    type="number"
                    className="s2"
                    style={{
                      paddingRight: "3pt",
                      textIndent: "0pt",
                      textAlign: "center",
                      backgroundColor: "lightblue",
                      outline: "none",
                    }}
                    name="standard_deduction"
                    value={formData.standard_deduction} // Assuming this is the correct property name
                    onChange={handleInputChange}
                  />
                </td>
                <td
                  style={{
                    width: "78pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "72pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
              </tr>
              <tr style={{ height: "11pt" }}>
                <td
                  style={{
                    width: "79pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p style={{ textIndent: "0pt", textAlign: "center" }}>
                    {formData.entertainment_allowance}
                  </p>
                </td>
                <td
                  style={{
                    width: "78pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "center" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "72pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    textAlign: "center",
                    borderColor: "blue",
                    textAlign: "center",
                    width: "79pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",

                    borderBottomStyle: "solid",
                    borderBottomWidth: "2pt",
                    backgroundColor: "lightblue",
                  }}
                >
                  <input
                    name="total_pt"
                    type="number"
                    className="s2"
                    style={{
                      paddingRight: "3pt",
                      textIndent: "0pt",
                      backgroundColor: "lightblue",
                      outline: "none",
                      textAlign: "center",
                    }}
                    value={formData.total_pt}
                    onChange={handleInputChange}
                  />
                </td>
                <td
                  style={{
                    width: "78pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "72pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
              </tr>
              <tr style={{ height: "11pt" }}>
                <td
                  style={{
                    width: "79pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "78pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p
                    className="s2"
                    style={{
                      paddingRight: "3pt",
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "center",
                    }}
                  >
                    {formData.total_deduction}
                  </p>
                </td>
                <td
                  style={{
                    width: "72pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
              </tr>
              <tr style={{ height: "11pt" }}>
                <td
                  style={{
                    width: "79pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "78pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "72pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p
                    className="s2"
                    style={{
                      paddingRight: "3pt",
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "center",
                    }}
                  >
                    {formData.chargebale_income}
                  </p>
                </td>
              </tr>
              <tr style={{ height: "11pt" }}>
                <td
                  style={{
                    width: "79pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "78pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "72pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
              </tr>
              <tr style={{ height: "11pt" }}>
                <td
                  style={{
                    width: "79pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p
                    className="s2"
                    style={{
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "left",
                    }}
                  ></p>
                </td>
                <td
                  style={{
                    width: "78pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "72pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
              </tr>
              <tr style={{ height: "11pt" }}>
                <td
                  style={{
                    width: "88pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p
                    className="s2"
                    style={{
                      paddingLeft: "1pt",
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "center",
                    }}
                  >
                    Income
                  </p>
                </td>
                <td
                  style={{
                    width: "109pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p
                    className="s2"
                    style={{
                      paddingLeft: "1pt",
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "center",
                    }}
                  >
                    Rs.
                  </p>
                </td>
                <td
                  style={{
                    width: "79pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "78pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "72pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
              </tr>
              <tr style={{ height: "11pt" }}>
                <td
                  style={{
                    width: "88pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "109pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "79pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "78pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "72pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
              </tr>
              <tr style={{ height: "11pt" }}>
                <td
                  style={{
                    width: "88pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "109pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "79pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "78pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "72pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
              </tr>
              <tr style={{ height: "11pt" }}>
                <td
                  style={{
                    width: "88pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "109pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "79pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "78pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p
                    className="s2"
                    style={{
                      paddingRight: "12pt",
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "center",
                    }}
                  >
                    -
                  </p>
                </td>
                <td
                  style={{
                    width: "72pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
              </tr>
              <tr style={{ height: "11pt" }}>
                <td
                  style={{
                    width: "197pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  colSpan={2}
                  rowSpan={2}
                >
                  <p
                    style={{
                      paddingTop: "1pt",
                      textIndent: "0pt",
                      textAlign: "left",
                    }}
                  >
                    <br />
                  </p>
                  <p
                    className="s2"
                    style={{
                      paddingLeft: "1pt",
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "left",
                    }}
                  >
                    8. Gross Total income (6+7)
                  </p>
                </td>
                <td
                  style={{
                    width: "79pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "78pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "72pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
              </tr>
              <tr style={{ height: "11pt" }}>
                <td
                  style={{
                    width: "79pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "78pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "72pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p
                    className="s2"
                    style={{
                      paddingRight: "3pt",
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "center",
                    }}
                  >
                    {formData.gross_total_income}
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
          <p
            style={{ paddingTop: "3pt", textIndent: "0pt", textAlign: "left" }}
          >
            <br />
          </p>

          <p />
          <table
            style={{
              borderCollapse: "collapse",
              width: "90%",
              marginLeft: "27.895pt",
            }}
            cellSpacing={0}
          >
            <tbody>
              <tr style={{ height: "12pt" }}>
                <td
                  style={{
                    width: "197pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  rowSpan={15}
                >
                  <ol id="l5">
                    <li data-list-text={9}>
                      <p
                        className="s2"
                        style={{
                          paddingLeft: "9pt",
                          textIndent: "-8pt",
                          lineHeight: "10pt",
                          textAlign: "left",
                        }}
                      >
                        Deductions under Chapter VI A
                      </p>
                      <ol id="l6">
                        <li data-list-text="(A)">
                          <p
                            className="s2"
                            style={{
                              paddingLeft: "26pt",
                              textIndent: "-14pt",
                              textAlign: "left",
                            }}
                          >
                            sections 80C, 80CCC and 80CCD
                          </p>
                          <p
                            style={{
                              paddingTop: "1pt",
                              textIndent: "0pt",
                              textAlign: "left",
                            }}
                          >
                            <br />
                          </p>
                          <ol id="l7">
                            <li data-list-text="(a)">
                              <p
                                className="s2"
                                style={{
                                  paddingLeft: "37pt",
                                  textIndent: "-12pt",
                                  textAlign: "left",
                                }}
                              >
                                Section 80 C
                              </p>
                              <ol id="l8">
                                <li data-list-text="(i)">
                                  <p
                                    className="s2"
                                    style={{
                                      marginTop: "20pt",
                                      paddingLeft: "42pt",
                                      paddingRight: "72pt",
                                      textIndent: "0pt",
                                      lineHeight: "107%",
                                      textAlign: "left",
                                    }}
                                  >
                                    Contribution to PF
                                  </p>
                                  <td
                                    style={{
                                      marginTop: "5pt",
                                      textAlign: "center",
                                      width: "",
                                      borderColor: "blue",
                                      borderBottomStyle: "solid",
                                      borderBottomWidth: "2pt",
                                      backgroundColor: "lightblue",
                                      display: "flex",
                                      lineHeight: "19pt",
                                    }}
                                  >
                                    <span className="s2">(ii)</span>
                                    <input
                                      name="section_80c_2_label"
                                      type="text"
                                      className="s2"
                                      style={{
                                        marginTop: "6pt",
                                        paddingLeft: "42pt",
                                        textIndent: "0pt",
                                        lineHeight: "11pt",
                                        textAlign: "left",
                                        backgroundColor: "lightblue",
                                        outline: "none",
                                      }}
                                      value={formData.section_80c_2_label}
                                      onChange={handleInputChange}
                                    />
                                  </td>
                                  <td
                                    style={{
                                      lineHeight: "19pt",
                                      textAlign: "center",
                                      width: "",
                                      borderColor: "blue",
                                      borderBottomStyle: "solid",
                                      borderBottomWidth: "2pt",
                                      backgroundColor: "lightblue",
                                      display: "flex",
                                    }}
                                  >
                                    <span className="s2">(iii)</span>
                                    <input
                                      name="section_80c_3_label"
                                      type="text"
                                      className="s2"
                                      style={{
                                        marginTop: "6pt",
                                        paddingLeft: "42pt",
                                        textIndent: "0pt",
                                        lineHeight: "10pt",
                                        textAlign: "left",
                                        backgroundColor: "lightblue",
                                        outline: "none",
                                      }}
                                      value={formData.section_80c_3_label}
                                      onChange={handleInputChange}
                                    />
                                  </td>
                                  <td
                                    style={{
                                      marginTop: "0pt",
                                      textAlign: "center",
                                      width: "",
                                      borderColor: "blue",
                                      borderBottomStyle: "solid",
                                      borderBottomWidth: "2pt",
                                      backgroundColor: "lightblue",
                                      display: "flex",
                                    }}
                                  >
                                    <span className="s2">(iv)</span>
                                    <input
                                      name="section_80c_4_label"
                                      type="text"
                                      className="s2"
                                      style={{
                                        marginTop: "6pt",
                                        paddingLeft: "42pt",
                                        textIndent: "0pt",
                                        lineHeight: "11pt",
                                        textAlign: "left",
                                        backgroundColor: "lightblue",
                                        outline: "none",
                                      }}
                                      value={formData.section_80c_4_label}
                                      onChange={handleInputChange}
                                    />
                                  </td>
                                  <td
                                    style={{
                                      marginTop: "0pt",
                                      textAlign: "center",
                                      width: "",
                                      borderColor: "blue",
                                      borderBottomStyle: "solid",
                                      borderBottomWidth: "2pt",
                                      backgroundColor: "lightblue",
                                      display: "flex",
                                    }}
                                  >
                                    <span className="s2">(v)</span>
                                    <input
                                      name="section_80c_5_label"
                                      type="text"
                                      className="s2"
                                      style={{
                                        marginTop: "6pt",
                                        paddingLeft: "42pt",
                                        textIndent: "0pt",
                                        lineHeight: "11pt",
                                        textAlign: "left",
                                        backgroundColor: "lightblue",
                                        outline: "none",
                                      }}
                                      value={formData.section_80c_5_label}
                                      onChange={handleInputChange}
                                    />
                                  </td>
                                  <td
                                    style={{
                                      lineHeight: "19pt",
                                      textAlign: "center",
                                      width: "",
                                      borderColor: "blue",
                                      borderBottomStyle: "solid",
                                      borderBottomWidth: "2pt",
                                      backgroundColor: "lightblue",
                                      display: "flex",
                                    }}
                                  >
                                    <span className="s2">(vi)</span>
                                    <input
                                      name="section_80c_6_label"
                                      type="text"
                                      className="s2"
                                      style={{
                                        marginTop: "6pt",
                                        paddingLeft: "42pt",
                                        textIndent: "0pt",
                                        lineHeight: "10pt",
                                        textAlign: "left",
                                        backgroundColor: "lightblue",
                                        outline: "none",
                                      }}
                                      value={formData.section_80c_6_label}
                                      onChange={handleInputChange}
                                    />
                                  </td>
                                  {/* <td
                                    style={{
                                      lineHeight: "19pt",
                                      textAlign: "center",
                                      width: "",
                                      borderColor: "blue",
                                      borderBottomStyle: "solid",
                                      borderBottomWidth: "2pt",
                                      backgroundColor: "lightblue",
                                      display: "flex",
                                    }}
                                  >
                                    <span className="s2">(vii)</span>
                                    <input
                                      name="section_80c_7_label"
                                      type="text"
                                      className="s2"
                                      style={{
                                        marginTop: "6pt",
                                        paddingLeft: "42pt",
                                        textIndent: "0pt",
                                        lineHeight: "10pt",
                                        textAlign: "left",
                                        backgroundColor: "lightblue",
                                        outline: "none",
                                      }}
                                      value={formData.section_80c_7_label}
                                      onChange={handleInputChange}
                                    />
                                  </td> */}
                                  {/* <td
                                    style={{
                                      lineHeight: "19pt",
                                      textAlign: "center",
                                      width: "",
                                      borderColor: "blue",
                                      borderBottomStyle: "solid",
                                      borderBottomWidth: "2pt",
                                      backgroundColor: "lightblue",
                                      display: "flex",
                                    }}
                                  >
                                    <span className="s2">(viii)</span>
                                    <input
                                      name="section_80c_8_label"
                                      type="text"
                                      className="s2"
                                      style={{
                                        marginTop: "6pt",
                                        paddingLeft: "42pt",
                                        textIndent: "0pt",
                                        lineHeight: "10pt",
                                        textAlign: "left",
                                        backgroundColor: "lightblue",
                                        outline: "none",
                                      }}
                                      value={formData.section_80c_8_label}
                                      onChange={handleInputChange}
                                    />
                                  </td> */}
                                </li>
                              </ol>
                            </li>
                            <li data-list-text="(b)">
                              <p
                                className="s2"
                                style={{
                                  paddingLeft: "39pt",
                                  textIndent: "-12pt",
                                  textAlign: "left",
                                }}
                              >
                                section 80 CCC
                              </p>
                            </li>
                            <li data-list-text="(c)">
                              <p
                                className="s2"
                                style={{
                                  paddingLeft: "38pt",
                                  textIndent: "-11pt",
                                  textAlign: "left",
                                }}
                              >
                                section 80 CCD
                              </p>
                            </li>
                          </ol>
                        </li>
                      </ol>
                    </li>
                  </ol>
                </td>
                <td
                  style={{
                    width: "79pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "78pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "72pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
              </tr>
              <tr style={{ height: "12pt" }}>
                <td
                  style={{
                    width: "79pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "78pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "72pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
              </tr>
              <tr style={{ height: "12pt" }}>
                <td
                  style={{
                    width: "79pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "78pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "72pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
              </tr>
              <tr style={{ height: "12pt" }}>
                <td
                  style={{
                    width: "79pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "78pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p
                    className="s2"
                    style={{
                      paddingLeft: "11pt",
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "center",
                    }}
                  >
                    Gross Amount
                  </p>
                </td>
                <td
                  style={{
                    width: "72pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                  }}
                >
                  <p
                    className="s4"
                    style={{
                      textIndent: "0pt",
                      lineHeight: "9pt",
                      textAlign: "center",
                    }}
                  >
                    Deductible Amount
                  </p>
                </td>
              </tr>
              <tr style={{ height: "12pt" }}>
                <td
                  style={{
                    width: "79pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    textAlign: "center",
                    width: "78pt",
                    borderColor: "blue",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "2pt",
                    backgroundColor: "lightblue",
                  }}
                >
                  <input
                    name="contribution_pf_gross_amount"
                    type="number"
                    className="s2"
                    style={{
                      paddingRight: "4pt",
                      textIndent: "0pt",
                      outline: "none",
                      textAlign: "center",
                      backgroundColor: "lightblue",
                    }}
                    value={formData.contribution_pf_gross_amount}
                    onChange={handleInputChange}
                  />
                </td>
                <td
                  style={{
                    width: "72pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p
                    className="s2"
                    style={{
                      paddingRight: "4pt",
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "center",
                    }}
                  >
                    {formData.contribution_pf_deduction_amount}
                  </p>
                </td>
              </tr>
              <tr style={{ height: "12pt" }}>
                <td
                  style={{
                    width: "79pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    textAlign: "center",
                    width: "78pt",
                    borderColor: "blue",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "2pt",
                    backgroundColor: "lightblue",
                  }}
                >
                  <input
                    name="section_80c_2_gross_amount"
                    type="number"
                    className="s2"
                    style={{
                      paddingRight: "4pt",
                      textIndent: "0pt",
                      outline: "none",
                      textAlign: "center",
                      backgroundColor: "lightblue",
                    }}
                    value={formData.section_80c_2_gross_amount}
                    onChange={handleInputChange}
                  />
                  {/* <p style={{ textIndent: "0pt", textAlign: "center" }}>
                    {formData.section_80c_2_gross_amount}
                  </p> */}
                </td>
                <td
                  style={{
                    width: "72pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p
                    className="s2"
                    style={{
                      paddingRight: "12pt",
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "center",
                    }}
                  >
                    {formData.section_80c_2_deduction_amount}
                  </p>
                </td>
              </tr>
              <tr style={{ height: "12pt" }}>
                <td
                  style={{
                    width: "79pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    textAlign: "center",
                    width: "78pt",
                    borderColor: "blue",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "2pt",
                    backgroundColor: "lightblue",
                  }}
                >
                  <input
                    name="section_80c_3_gross_amount"
                    type="number"
                    className="s2"
                    style={{
                      paddingRight: "4pt",
                      textIndent: "0pt",
                      outline: "none",
                      textAlign: "center",
                      backgroundColor: "lightblue",
                    }}
                    value={formData.section_80c_3_gross_amount}
                    onChange={handleInputChange}
                  />
                </td>
                <td
                  style={{
                    width: "72pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p
                    className="s2"
                    style={{
                      paddingRight: "12pt",
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "center",
                    }}
                  >
                    {formData.section_80c_3_deduction_amount}
                  </p>
                </td>
              </tr>
              <tr style={{ height: "12pt" }}>
                <td
                  style={{
                    width: "79pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    textAlign: "center",
                    width: "78pt",
                    borderColor: "blue",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "2pt",
                    backgroundColor: "lightblue",
                  }}
                >
                  <input
                    name="section_80c_4_gross_amount"
                    type="number"
                    className="s2"
                    style={{
                      paddingRight: "4pt",
                      textIndent: "0pt",
                      outline: "none",
                      textAlign: "center",
                      backgroundColor: "lightblue",
                    }}
                    value={formData.section_80c_4_gross_amount}
                    onChange={handleInputChange}
                  />
                </td>
                <td
                  style={{
                    width: "72pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p
                    className="s2"
                    style={{
                      paddingRight: "12pt",
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "center",
                    }}
                  >
                    {formData.section_80c_4_deduction_amount}
                  </p>
                </td>
              </tr>
              <tr style={{ height: "12pt" }}>
                <td
                  style={{
                    width: "79pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    textAlign: "center",
                    width: "78pt",
                    borderColor: "blue",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "2pt",
                    backgroundColor: "lightblue",
                  }}
                >
                  <input
                    name="section_80c_5_gross_amount"
                    type="number"
                    className="s2"
                    style={{
                      paddingRight: "4pt",
                      textIndent: "0pt",
                      outline: "none",
                      textAlign: "center",
                      backgroundColor: "lightblue",
                    }}
                    value={formData.section_80c_5_gross_amount}
                    onChange={handleInputChange}
                  />
                </td>
                <td
                  style={{
                    width: "72pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p
                    className="s2"
                    style={{
                      paddingRight: "12pt",
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "center",
                    }}
                  >
                    {formData.section_80c_5_deduction_amount}
                  </p>
                </td>
              </tr>
              <tr style={{ height: "12pt" }}>
                <td
                  style={{
                    width: "79pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    textAlign: "center",
                    width: "78pt",
                    borderColor: "blue",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "2pt",
                    backgroundColor: "lightblue",
                  }}
                >
                  <input
                    name="section_80c_6_gross_amount"
                    type="number"
                    className="s2"
                    style={{
                      paddingRight: "4pt",
                      textIndent: "0pt",
                      outline: "none",
                      textAlign: "center",
                      backgroundColor: "lightblue",
                    }}
                    value={formData.section_80c_6_gross_amount}
                    onChange={handleInputChange}
                  />
                </td>
                <td
                  style={{
                    width: "72pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p
                    className="s2"
                    style={{
                      paddingRight: "12pt",
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "center",
                    }}
                  >
                    {formData.section_80c_6_deduction_amount}
                  </p>
                </td>
              </tr>
              <tr style={{ height: "12pt" }}>
                <td
                  style={{
                    width: "79pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    textAlign: "center",
                    width: "78pt",
                    borderColor: "blue",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "2pt",
                    backgroundColor: "lightblue",
                  }}
                >
                  <input
                    name="section_80c_7_gross_amount"
                    type="number"
                    className="s2"
                    style={{
                      paddingRight: "4pt",
                      textIndent: "0pt",
                      outline: "none",
                      textAlign: "center",
                      backgroundColor: "lightblue",
                    }}
                    value={formData.section_80c_7_gross_amount}
                    onChange={handleInputChange}
                  />
                </td>
                <td
                  style={{
                    width: "72pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p
                    className="s2"
                    style={{
                      paddingRight: "12pt",
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "center",
                    }}
                  >
                    {formData.section_80c_7_deduction_amount}
                  </p>
                </td>
              </tr>
              <tr style={{ height: "12pt" }}>
                <td
                  style={{
                    width: "79pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    textAlign: "center",
                    width: "78pt",
                    borderColor: "blue",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "2pt",
                    backgroundColor: "lightblue",
                  }}
                >
                  <input
                    name="section_80c_8_gross_amount"
                    type="number"
                    className="s2"
                    style={{
                      paddingRight: "4pt",
                      textIndent: "0pt",
                      outline: "none",
                      textAlign: "center",
                      backgroundColor: "lightblue",
                    }}
                    value={formData.section_80c_8_gross_amount}
                    onChange={handleInputChange}
                  />
                </td>
                <td
                  style={{
                    width: "72pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p
                    className="s2"
                    style={{
                      paddingRight: "12pt",
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "center",
                    }}
                  >
                    {formData.section_80c_8_deduction_amount}
                  </p>
                </td>
              </tr>
              <tr style={{ height: "12pt" }}>
                <td
                  style={{
                    width: "79pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "78pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "72pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p
                    className="s2"
                    style={{
                      paddingRight: "12pt",
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "center",
                    }}
                  >
                    -
                  </p>
                </td>
              </tr>
              <tr style={{ height: "12pt" }}>
                <td
                  style={{
                    width: "79pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "78pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "72pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p
                    className="s2"
                    style={{
                      paddingRight: "12pt",
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "center",
                    }}
                  >
                    -
                  </p>
                </td>
              </tr>
              <tr style={{ height: "12pt" }}>
                <td
                  style={{
                    width: "79pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "78pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p
                    className="s2"
                    style={{
                      paddingRight: "4pt",
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "center",
                    }}
                  >
                    {formData.total_pf_gross_amount}
                  </p>
                </td>
                <td
                  style={{
                    width: "72pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p
                    className="s2"
                    style={{
                      paddingRight: "4pt",
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "center",
                    }}
                   
                  >
                    {formData.total_pf_deduction_amount}
                  </p>
                </td>
              </tr>
              <tr style={{ height: "13pt" }}>
                <td
                  style={{
                    width: "197pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  rowSpan={4}
                >
                  <p
                    className="s5"
                    style={{
                      paddingTop: "2pt",
                      paddingLeft: "24pt",
                      paddingRight: "5pt",
                      textIndent: "-11pt",
                      lineHeight: "108%",
                      textAlign: "left",
                      letterSpacing: "0.05em",
                    }}
                  >
                    Note: 1. Aggregate amount deductible under section 80 C
                    shall not exceed one lakh fifty thousand rupees.
                  </p>
                  <p
                    className="s5"
                    style={{
                      paddingTop: "6pt",
                      paddingLeft: "5pt",
                      textIndent: "0pt",
                      lineHeight: "158%",
                      textAlign: "left",
                      letterSpacing: "0.05em",
                    }}
                  >
                    2. Aggregate amount deductible under the three sections,
                    i.e. 80C,80CCC,80CCD shall not exceed one lakh fifty
                    thousand rupees.
                  </p>
                </td>
                <td
                  style={{
                    width: "79pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "78pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "72pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
              </tr>
              <tr style={{ height: "12pt" }}>
                <td
                  style={{
                    width: "79pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "78pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "72pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
              </tr>
              <tr style={{ height: "12pt" }}>
                <td
                  style={{
                    width: "79pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "78pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "72pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
              </tr>
              <tr style={{ height: "24pt" }}>
                <td
                  style={{
                    width: "79pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "78pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "72pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
              </tr>
              <tr style={{ height: "12pt" }}>
                <td
                  style={{
                    width: "197pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                  }}
                  rowSpan={17}
                >
                  <p
                    style={{
                      paddingTop: "2pt",
                      textIndent: "0pt",
                      textAlign: "left",
                    }}
                  >
                    <br />
                  </p>
                  <ol id="l9">
                    <li data-list-text="(B)">
                      <p
                        className="s3"
                        style={{
                          marginLeft: "21pt",
                          textIndent: "-11pt",
                          textAlign: "left",
                        }}
                      >
                        other sections (e.g. 80E,80G etc.) under Chapter VI A
                      </p>
                      <p
                        style={{
                          paddingTop: "2pt",
                          textIndent: "0pt",
                          textAlign: "left",
                        }}
                      >
                        <br />
                      </p>
                      <ol id="l10">
                        <li data-list-text="(i)">
                          <td
                            style={{
                              lineHeight: "19pt",
                              textAlign: "center",
                              width: "",
                              borderColor: "blue",
                              borderBottomStyle: "solid",
                              borderBottomWidth: "2pt",
                              backgroundColor: "lightblue",
                              display: "flex",
                            }}
                          >
                            <input
                              name="other_section_1_label"
                              type="text"
                              className="s2"
                              style={{
                                marginTop: "6pt",
                                paddingLeft: "42pt",
                                textIndent: "0pt",
                                lineHeight: "10pt",
                                textAlign: "left",
                                backgroundColor: "lightblue",
                                outline: "none",
                              }}
                              value={formData.other_section_1_label}
                              onChange={handleInputChange}
                            />
                          </td>
                        </li>
                        <li data-list-text="(ii)">
                          <td
                            style={{
                              lineHeight: "19pt",
                              textAlign: "center",
                              width: "",
                              borderColor: "blue",
                              borderBottomStyle: "solid",
                              borderBottomWidth: "2pt",
                              backgroundColor: "lightblue",
                              display: "flex",
                            }}
                          >
                            <input
                              name="other_section_2_label"
                              type="text"
                              className="s2"
                              style={{
                                marginTop: "6pt",
                                paddingLeft: "42pt",
                                textIndent: "0pt",
                                lineHeight: "10pt",
                                textAlign: "left",
                                backgroundColor: "lightblue",
                                outline: "none",
                              }}
                              value={formData.other_section_2_label}
                              onChange={handleInputChange}
                            />
                          </td>
                        </li>
                        <li data-list-text="(iii)">
                          <td
                            style={{
                              lineHeight: "19pt",
                              textAlign: "center",
                              width: "",
                              borderColor: "blue",
                              borderBottomStyle: "solid",
                              borderBottomWidth: "2pt",
                              backgroundColor: "lightblue",
                              display: "flex",
                            }}
                          >
                            <input
                              name="other_section_3_label"
                              type="text"
                              className="s2"
                              style={{
                                marginTop: "6pt",
                                paddingLeft: "42pt",
                                textIndent: "0pt",
                                lineHeight: "10pt",
                                textAlign: "left",
                                backgroundColor: "lightblue",
                                outline: "none",
                              }}
                              value={formData.other_section_3_label}
                              onChange={handleInputChange}
                            />
                          </td>
                        </li>
                        <li data-list-text="(iv)">
                          <td
                            style={{
                              lineHeight: "19pt",
                              textAlign: "center",
                              width: "",
                              borderColor: "blue",
                              borderBottomStyle: "solid",
                              borderBottomWidth: "2pt",
                              backgroundColor: "lightblue",
                              display: "flex",
                            }}
                          >
                            <input
                              name="other_section_4_label"
                              type="text"
                              className="s2"
                              style={{
                                marginTop: "6pt",
                                paddingLeft: "42pt",
                                textIndent: "0pt",
                                lineHeight: "10pt",
                                textAlign: "left",
                                backgroundColor: "lightblue",
                                outline: "none",
                              }}
                              value={formData.other_section_4_label}
                              onChange={handleInputChange}
                            />
                          </td>
                        </li>
                        <li data-list-text="(v)">
                          <td
                            style={{
                              lineHeight: "19pt",
                              textAlign: "center",
                              width: "",
                              borderColor: "blue",
                              borderBottomStyle: "solid",
                              borderBottomWidth: "2pt",
                              backgroundColor: "lightblue",
                              display: "flex",
                            }}
                          >
                            <input
                              name="other_section_5_label"
                              type="text"
                              className="s2"
                              style={{
                                marginTop: "6pt",
                                paddingLeft: "42pt",
                                textIndent: "0pt",
                                lineHeight: "10pt",
                                textAlign: "left",
                                backgroundColor: "lightblue",
                                outline: "none",
                              }}
                              value={formData.other_section_5_label}
                              onChange={handleInputChange}
                            />
                          </td>
                        </li>
                      </ol>
                    </li>
                  </ol>
                  <p
                    style={{
                      paddingTop: "1pt",
                      textIndent: "0pt",
                      textAlign: "left",
                    }}
                  >
                    <br />
                  </p>
                  <ol id="l11">
                    <li data-list-text={10}>
                      <p
                        className="s4"
                        style={{
                          paddingLeft: "12pt",
                          paddingRight: "2pt",
                          textIndent: "-12pt",
                          textAlign: "left",
                        }}
                      >
                        Aggregate of deductible amount under Chapter VI A
                      </p>
                      <p
                        style={{
                          paddingTop: "2pt",
                          textIndent: "0pt",
                          textAlign: "left",
                        }}
                      >
                        <br />
                      </p>
                    </li>
                    <li data-list-text={11}>
                      <p
                        className="s2"
                        style={{
                          paddingLeft: "14pt",
                          textIndent: "-12pt",
                          textAlign: "left",
                        }}
                      >
                        Total Income (8-10)
                      </p>
                    </li>
                    <li data-list-text={12}>
                      <p
                        className="s2"
                        style={{
                          marginTop: "5pt",
                          paddingLeft: "14pt",
                          textIndent: "-12pt",
                          textAlign: "left",
                        }}
                      >
                        Tax on total income
                      </p>
                    </li>
                    <li data-list-text={13}>
                      <p
                        className="s4"
                        style={{
                          marginTop: "10pt",
                          paddingLeft: "11pt",
                          textIndent: "-12pt",
                          textAlign: "left",
                        }}
                      >
                        Education cess @ 4% (on tax computed at S.No. 12)
                      </p>
                    </li>
                    <li data-list-text={14}>
                      <p
                        className="s2"
                        style={{
                          marginTop: "10pt",
                          paddingLeft: "14pt",
                          textIndent: "-12pt",
                          textAlign: "left",
                        }}
                      >
                        Tax Payable (12+13)
                      </p>
                    </li>
                    <li data-list-text={15}>
                      <p
                        className="s2"
                        style={{
                          marginTop: "5pt",
                          paddingLeft: "14pt",
                          textIndent: "-12pt",
                          textAlign: "left",
                        }}
                      >
                        Less: Relief under section 89 (attach details)
                      </p>
                    </li>
                    <li data-list-text={16}>
                      <p
                        className="s2"
                        style={{
                          marginTop: "5pt",
                          paddingLeft: "14pt",
                          textIndent: "-12pt",
                          lineHeight: "10pt",
                          textAlign: "left",
                        }}
                      >
                        Tax Payable (14-15)
                      </p>
                    </li>
                  </ol>
                </td>
                <td
                  style={{
                    width: "79pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "78pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "72pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
              </tr>
              <tr style={{ height: "12pt" }}>
                <td
                  style={{
                    width: "79pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                    textAlign: "center",
                    alignItems: "center",
                  }}
                >
                  <p
                    className="s2"
                    style={{
                      // paddingRight: "10pt",
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "center",
                    }}
                  >
                    Gross Amount
                  </p>
                </td>
                <td
                  style={{
                    width: "78pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p
                    className="s2"
                    style={{
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "center",
                    }}
                  >
                    Qualifying Amount
                  </p>
                </td>
                <td
                  style={{
                    width: "72pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                  }}
                >
                  <p
                    className="s2"
                    style={{
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "center",
                    }}
                  >
                    Deductible Amount
                  </p>
                </td>
              </tr>
              <tr style={{ height: "12pt" }}>
                <td
                  style={{
                    width: "79pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "78pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "72pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
              </tr>
              <tr style={{ height: "12pt" }}>
                <td
                  style={{
                    lineHeight: "19pt",
                    textAlign: "center",
                    width: "",
                    borderColor: "blue",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "2pt",
                    backgroundColor: "lightblue",
                  }}
                >
                  <input
                    name="other_section_1_gross_amount"
                    type="text"
                    className="s2"
                    style={{
                      marginTop: "6pt",

                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "center",
                      backgroundColor: "lightblue",
                      outline: "none",
                    }}
                    value={formData.other_section_1_gross_amount}
                    onChange={handleInputChange}
                  />
                </td>
                <td
                  style={{
                    lineHeight: "19pt",
                    textAlign: "center",
                    width: "",
                    borderColor: "blue",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "2pt",
                    backgroundColor: "lightblue",
                  }}
                >
                  <input
                    name="other_section_1_qualify_amount"
                    type="text"
                    className="s2"
                    style={{
                      marginTop: "6pt",

                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "center",
                      backgroundColor: "lightblue",
                      outline: "none",
                    }}
                    value={formData.other_section_1_qualify_amount}
                    onChange={handleInputChange}
                  />
                </td>
                <td
                  style={{
                    lineHeight: "19pt",
                    textAlign: "center",
                    width: "",
                    borderColor: "blue",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "2pt",
                    backgroundColor: "lightblue",
                  }}
                >
                  <input
                    name="other_section_1_deduction_amount"
                    type="text"
                    className="s2"
                    style={{
                      marginTop: "6pt",

                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "center",
                      backgroundColor: "lightblue",
                      outline: "none",
                    }}
                    value={formData.other_section_1_deduction_amount}
                    onChange={handleInputChange}
                  />
                </td>
              </tr>
              <tr style={{ height: "12pt" }}>
                <td
                  style={{
                    lineHeight: "19pt",
                    textAlign: "center",
                    width: "",
                    borderColor: "blue",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "2pt",
                    backgroundColor: "lightblue",
                  }}
                >
                  <input
                    name="other_section_2_gross_amount"
                    type="text"
                    className="s2"
                    style={{
                      marginTop: "6pt",

                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "center",
                      backgroundColor: "lightblue",
                      outline: "none",
                    }}
                    value={formData.other_section_2_gross_amount}
                    onChange={handleInputChange}
                  />
                </td>
                <td
                  style={{
                    lineHeight: "19pt",
                    textAlign: "center",
                    width: "",
                    borderColor: "blue",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "2pt",
                    backgroundColor: "lightblue",
                  }}
                >
                  <input
                    name="other_section_2_qualify_amount"
                    type="text"
                    className="s2"
                    style={{
                      marginTop: "6pt",

                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "center",
                      backgroundColor: "lightblue",
                      outline: "none",
                    }}
                    value={formData.other_section_2_qualify_amount}
                    onChange={handleInputChange}
                  />
                </td>
                <td
                  style={{
                    lineHeight: "19pt",
                    textAlign: "center",
                    width: "",
                    borderColor: "blue",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "2pt",
                    backgroundColor: "lightblue",
                  }}
                >
                  <input
                    name="other_section_2_deduction_amount"
                    type="text"
                    className="s2"
                    style={{
                      marginTop: "6pt",

                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "center",
                      backgroundColor: "lightblue",
                      outline: "none",
                    }}
                    value={formData.other_section_2_deduction_amount}
                    onChange={handleInputChange}
                  />
                </td>
              </tr>
              <tr style={{ height: "12pt" }}>
                <td
                  style={{
                    lineHeight: "19pt",
                    textAlign: "center",
                    width: "",
                    borderColor: "blue",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "2pt",
                    backgroundColor: "lightblue",
                  }}
                >
                  <input
                    name="other_section_3_gross_amount"
                    type="text"
                    className="s2"
                    style={{
                      marginTop: "6pt",

                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "center",
                      backgroundColor: "lightblue",
                      outline: "none",
                    }}
                    value={formData.other_section_3_gross_amount}
                    onChange={handleInputChange}
                  />
                </td>
                <td
                  style={{
                    lineHeight: "19pt",
                    textAlign: "center",
                    width: "",
                    borderColor: "blue",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "2pt",
                    backgroundColor: "lightblue",
                  }}
                >
                  <input
                    name="other_section_3_qualify_amount"
                    type="text"
                    className="s2"
                    style={{
                      marginTop: "6pt",

                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "center",
                      backgroundColor: "lightblue",
                      outline: "none",
                    }}
                    value={formData.other_section_3_qualify_amount}
                    onChange={handleInputChange}
                  />
                </td>
                <td
                  style={{
                    lineHeight: "19pt",
                    textAlign: "center",
                    width: "",
                    borderColor: "blue",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "2pt",
                    backgroundColor: "lightblue",
                  }}
                >
                  <input
                    name="other_section_3_deduction_amount"
                    type="text"
                    className="s2"
                    style={{
                      marginTop: "6pt",

                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "center",
                      backgroundColor: "lightblue",
                      outline: "none",
                    }}
                    value={formData.other_section_3_deduction_amount}
                    onChange={handleInputChange}
                  />
                </td>
              </tr>
              <tr style={{ height: "12pt" }}>
                <td
                  style={{
                    lineHeight: "19pt",
                    textAlign: "center",
                    width: "",
                    borderColor: "blue",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "2pt",
                    backgroundColor: "lightblue",
                  }}
                >
                  <input
                    name="other_section_4_gross_amount"
                    type="text"
                    className="s2"
                    style={{
                      marginTop: "6pt",

                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "center",
                      backgroundColor: "lightblue",
                      outline: "none",
                    }}
                    value={formData.other_section_4_gross_amount}
                    onChange={handleInputChange}
                  />
                </td>
                <td
                  style={{
                    lineHeight: "19pt",
                    textAlign: "center",
                    width: "",
                    borderColor: "blue",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "2pt",
                    backgroundColor: "lightblue",
                  }}
                >
                  <input
                    name="other_section_4_qualify_amount"
                    type="text"
                    className="s2"
                    style={{
                      marginTop: "6pt",

                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "center",
                      backgroundColor: "lightblue",
                      outline: "none",
                    }}
                    value={formData.other_section_4_qualify_amount}
                    onChange={handleInputChange}
                  />
                </td>
                <td
                  style={{
                    lineHeight: "19pt",
                    textAlign: "center",
                    width: "",
                    borderColor: "blue",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "2pt",
                    backgroundColor: "lightblue",
                  }}
                >
                  <input
                    name="other_section_4_deduction_amount"
                    type="text"
                    className="s2"
                    style={{
                      marginTop: "6pt",

                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "center",
                      backgroundColor: "lightblue",
                      outline: "none",
                    }}
                    value={formData.other_section_4_deduction_amount}
                    onChange={handleInputChange}
                  />
                </td>
              </tr>

              <tr style={{ height: "12pt" }}>
                <td
                  style={{
                    lineHeight: "19pt",
                    textAlign: "center",
                    width: "",
                    borderColor: "blue",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "2pt",
                    backgroundColor: "lightblue",
                  }}
                >
                  <input
                    name="other_section_5_gross_amount"
                    type="text"
                    className="s2"
                    style={{
                      marginTop: "6pt",

                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "center",
                      backgroundColor: "lightblue",
                      outline: "none",
                    }}
                    value={formData.other_section_5_gross_amount}
                    onChange={handleInputChange}
                  />
                </td>
                <td
                  style={{
                    lineHeight: "19pt",
                    textAlign: "center",
                    width: "",
                    borderColor: "blue",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "2pt",
                    backgroundColor: "lightblue",
                  }}
                >
                  <input
                    name="other_section_5_qualify_amount"
                    type="text"
                    className="s2"
                    style={{
                      marginTop: "6pt",

                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "center",
                      backgroundColor: "lightblue",
                      outline: "none",
                    }}
                    value={formData.other_section_5_qualify_amount}
                    onChange={handleInputChange}
                  />
                </td>
                <td
                  style={{
                    lineHeight: "19pt",
                    textAlign: "center",
                    width: "",
                    borderColor: "blue",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "2pt",
                    backgroundColor: "lightblue",
                  }}
                >
                  <input
                    name="other_section_5_deduction_amount"
                    type="text"
                    className="s2"
                    style={{
                      marginTop: "6pt",

                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "center",
                      backgroundColor: "lightblue",
                      outline: "none",
                    }}
                    value={formData.other_section_5_deduction_amount}
                    onChange={handleInputChange}
                  />
                </td>
              </tr>
              <tr style={{ height: "12pt" }}>
                <td
                  style={{
                    width: "79pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p style={{ textIndent: "0pt", textAlign: "center" }}>
                    {formData.other_section_gross_amount_total}
                  </p>
                </td>
                <td
                  style={{
                    width: "78pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p style={{ textIndent: "0pt", textAlign: "center" }}>
                    {formData.other_section_qualify_amount_total}
                  </p>
                </td>
                <td
                  style={{
                    width: "72pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p style={{ textIndent: "0pt", textAlign: "center" }}>
                    {formData.other_section_deduction_amount_total}
                  </p>
                </td>
              </tr>
              <tr style={{ height: "12pt" }}>
                <td
                  style={{
                    width: "79pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p
                    className="s4"
                    style={{
                      textIndent: "0pt",
                      lineHeight: "9pt",
                      textAlign: "left",
                    }}
                  ></p>
                </td>
                <td
                  style={{
                    width: "78pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "72pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p
                    className="s2"
                    style={{
                      paddingRight: "4pt",
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "center",
                    }}
                  >
                    {formData.deductible_amount_chapter_4}
                  </p>
                </td>
              </tr>
              <tr style={{ height: "12pt" }}>
                <td
                  style={{
                    width: "79pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "78pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "72pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
              </tr>
              <tr style={{ height: "12pt" }}>
                <td
                  style={{
                    width: "79pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "78pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "72pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p
                    className="s2"
                    style={{
                      paddingRight: "4pt",
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "center",
                    }}
                  >
                    {formData.final_income}
                  </p>
                </td>
              </tr>
              <tr style={{ height: "12pt" }}>
                <td
                  style={{
                    width: "79pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "78pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    textAlign: "center",
                    width: "72pt",
                    borderColor: "blue",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "2pt",
                    backgroundColor: "lightblue",
                  }}
                >
                  <input
                    name="total_tax"
                    type="number"
                    className="s2"
                    style={{
                      paddingRight: "4pt",
                      textIndent: "0pt",
                      backgroundColor: "lightblue",
                      outline: "none",
                      textAlign: "center",
                      outline: "none",
                    }}
                    value={formData.total_tax}
                    onChange={handleInputChange}
                  />
                </td>
              </tr>
              <tr style={{ height: "12pt" }}>
                <td
                  style={{
                    width: "79pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "78pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "72pt",
                    borderColor: "blue",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "2pt",
                    backgroundColor: "lightblue",
                    textAlign: "center",
                  }}
                >
                  <input
                    name="education_cess"
                    type="number"
                    className="s2"
                    style={{
                      paddingRight: "3pt",
                      textIndent: "0pt",
                      backgroundColor: "lightblue",
                      outline: "none",
                      textAlign: "center",
                    }}
                    value={formData.education_cess}
                    onChange={handleInputChange}
                  />
                </td>
              </tr>
              <tr style={{ height: "12pt" }}>
                <td
                  style={{
                    width: "79pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "78pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "72pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p
                    className="s2"
                    style={{
                      paddingRight: "4pt",
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "center",
                    }}
                  >
                    {formData.tax_payable}
                  </p>
                </td>
              </tr>
              <tr style={{ height: "12pt" }}>
                <td
                  style={{
                    width: "79pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "78pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "72pt",
                    backgroundColor: "lightblue",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "2pt",
                    borderColor: "blue",
                    textAlign: "center",
                  }}
                >
                  <input
                    name="less_relief"
                    type="number"
                    className="s2"
                    style={{
                      paddingRight: "4pt",
                      textIndent: "0pt",
                      backgroundColor: "lightblue",
                      textAlign: "center",
                      outline: "none",
                    }}
                    value={formData.less_relief}
                    onChange={handleInputChange}
                  />
                </td>
              </tr>
              <tr style={{ height: "12pt" }}>
                <td
                  style={{
                    width: "79pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "78pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  bgcolor="#BFBFBF"
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "72pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p
                    className="s2"
                    style={{
                      paddingLeft: "1pt",
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "center",
                    }}
                  >
                    {formData.total_tax_payable}
                  </p>
                </td>
              </tr>
              <tr style={{ height: "12pt" }}>
                <td
                  style={{
                    width: "426pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  colSpan={4}
                >
                  <p
                    className="s2"
                    style={{
                      paddingLeft: "1pt",
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "center",
                    }}
                  >
                    Verification
                  </p>
                </td>
              </tr>
              <tr style={{ height: "62pt" }}>
                <td
                  style={{
                    width: "426pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  colSpan={4}
                >
                  <p
                    style={{
                      paddingTop: "2pt",
                      textIndent: "0pt",
                      textAlign: "left",
                    }}
                  >
                    <br />
                  </p>
                  <p
                    className="s2"
                    style={{
                      paddingLeft: "1pt",
                      textIndent: "0pt",
                      lineHeight: "157%",
                      textAlign: "left",
                    }}
                  >
                    I, <u>MANAS PRAVIN ZATAKIYA</u>, son / <s>daughter</s> of{" "}
                    <u>PRAVIN ZATAKIYA</u> working in the capacity of{" "}
                    <u>ACCOUNTS MANAGER</u> do hereby certify that information
                    given above is true, complete and correct and is based on
                    the books of account, documents, TDS statements, TDS
                    deposited and other available records.{" "}
                  </p>
                </td>
              </tr>
              <tr style={{ height: "23pt" }}>
                <td
                  style={{
                    width: "88pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p
                    className="s2"
                    style={{
                      paddingTop: "5pt",
                      paddingLeft: "1pt",
                      paddingRight: "1pt",
                      textIndent: "0pt",
                      textAlign: "center",
                    }}
                  >
                    Place
                  </p>
                </td>
                <td
                  style={{
                    width: "109pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p
                    className="s2"
                    style={{
                      paddingTop: "5pt",
                      paddingLeft: "35pt",
                      textIndent: "0pt",
                      textAlign: "left",
                    }}
                  >
                    MUMBAI
                  </p>
                </td>
                <td
                  style={{
                    width: "229pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  colSpan={2}
                  rowSpan={3}
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
              </tr>
              <tr style={{ height: "12pt" }}>
                <td
                  style={{
                    width: "88pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p
                    className="s2"
                    style={{
                      paddingLeft: "1pt",
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "center",
                    }}
                  >
                    Date
                  </p>
                </td>
                <td
                  style={{
                    width: "109pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p
                    className="s2"
                    style={{
                      paddingLeft: "66pt",
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "left",
                    }}
                  >
                    {formatDate(new Date())}
                  </p>
                </td>
              </tr>
              <tr style={{ height: "12pt" }}>
                <td
                  style={{
                    width: "88pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  rowSpan={2}
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "109pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  rowSpan={2}
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
              </tr>
              <tr style={{ height: "12pt" }}>
                <td
                  style={{
                    width: "229pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  colSpan={2}
                >
                  <p
                    className="s2"
                    style={{
                      paddingLeft: "1pt",
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "left",
                    }}
                  >
                    Signature of person responsible for deduction of tax
                  </p>
                </td>
              </tr>
              <tr style={{ height: "12pt" }}>
                <td
                  style={{
                    width: "197pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                >
                  <p
                    className="s2"
                    style={{
                      paddingLeft: "1pt",
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "left",
                    }}
                  >
                    Designation: ACCOUNTS MANAGER
                  </p>
                </td>
                <td
                  style={{
                    width: "229pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                  }}
                  colSpan={3}
                >
                  <p
                    className="s2"
                    style={{
                      paddingLeft: "1pt",
                      textIndent: "0pt",
                      lineHeight: "10pt",
                      textAlign: "left",
                    }}
                  >
                    Full Name: MANAS ZATAKIYA
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="my-20 flex justify-center items-center">
          <button
            onClick={() => navigate(-1, { replace: true })}
            type="submit"
            className=" bg-[color:var(--color1)] text-white  py-3 px-20 rounded-xl"
          >
            Submit
          </button>
        </div>
      </form>
    </Layout>
  );
}

export default Form16Input;
